import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";
import { prefixPhoneNumberWithPlus } from "@utils/phoneNumberPrefix";

import { Patient } from "@customTypes/patient";

import { patientQKeys } from "./queryKeys";

// const select = (res: any) => {
//   //   console.log(res.data);

//   if (res.data.data.length) {
//     const newData: Partial<Patient>[] = [];

//     for (const i in res.data.data) {
//       const { patient_id, first_name, surname, dob, created_at } =
//         res.data.data[i];

//       newData.push({
//         patientId: patient_id,
//         firstName: first_name,
//         surname,
//         dob,
//         createdAt: new Date(created_at),
//       });
//     }
//     // console.log(newData);
//     return newData;
//   }
//   return null;
// };

interface QueryProps {
  isEnabled?: boolean;
  phoneNumber: string;
}

export const useGetPatientByPhoneNumber = ({
  phoneNumber,
  isEnabled = false,
}: QueryProps) => {
  return useQuery({
    queryKey: patientQKeys.phoneNumber(phoneNumber),
    queryFn: () => {
      return api.get(`patient/phone/${prefixPhoneNumberWithPlus(phoneNumber)}`);
    },
    // select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      if (res?.response?.status === 404) return;
      console.error("[From Get Patient By Phone]", res);
      //   handleErrors(res, "query");
    },
  });
};
